import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
const Blockly = GlobalImport.getBlockly();

export class VideoElement extends AbstractBlock {
  constructor() {
    super('video_elem_v2', t.to('動画', 'movie'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementShape(block);
    ColorSettings.setObjectColor(block);
    ShapeSettings.setTitleField(block, this.title);

    const typeField = ShapeSettings.getDropDown([
      [t.to('動画', 'movie'), 'a-video'],
      [t.to('全天球動画', 'videosphere'), 'a-videosphere'],
    ]);
    block
      .appendDummyInput()
      .appendField(t.to('種類', 'type') + ':')
      .appendField(typeField, 'type');

    const playField = ShapeSettings.getDropDown([
      [t.to('クリック', 'click'), 'click'],
      [t.to('自動再生', 'auto_play'), 'auto'],
    ]);
    block
      .appendDummyInput()
      .appendField(t.to('再生方法', 'play_method') + ':')
      .appendField(playField, 'play');

    const fieldText = new Blockly.FieldTextInput('');
    block
      .appendDummyInput()
      .appendField(t.to('ファイル', 'file') + ':')
      .appendField(fieldText, 'src');

    block.appendDummyInput().appendField(t.to('位置', 'position') + ':');
    ShapeSettings.setVR3Fields(block, 'position', 0, 1.7, 0);
    ShapeSettings.addAttributeInput(block);
  }

  generateStaticHTMLCode(): string {
    return `<link
			rel="stylesheet"
			href="https://cdnjs.cloudflare.com/ajax/libs/video.js/7.9.2/video-js.min.css"
			integrity="sha512-H0fVyBVJO8AQkwE782SHzeAvFZ9EdR3SkWrM0J+LeL0eRDUm4OdBNl1IRtmZflzVwOAJ7a3Ft8AfNw1G0MPqzQ=="
			crossorigin="anonymous"
			/>
			<script
				src="https://cdnjs.cloudflare.com/ajax/libs/video.js/7.9.2/video.min.js"
				integrity="sha512-8efB6+YJkaRJ6POD+FXbR/BXg9/8SSjQkP9S7utCJXak8bZmYROc5uhZtQeSEHcVHnkc0kGADYg9Ju60DD87Fw=="
				crossorigin="anonymous"
			></script>
			<script
				src="https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-hls/5.15.0/videojs-contrib-hls.min.js"
				integrity="sha512-R1+Pgd+uyqnjx07LGUmp85iW8MSL1iLR2ICPysFAt8Y4gub8C42B+aNG2ddOfCWcDDn1JPWZO4eby4+291xP9g=="
				crossorigin="anonymous"
			></script>
	`;
  }

  generateAssetsHTMLCode(block: BlockType): string {
    const src = CodeSetting.getFieldValue(block, 'src');
    const id = this.hashedId(block);

    // let html = `<video preload="auto" id="${id}" crossorigin autoplay loop="true" webkit-playsinline playsinline controls>`;
    let html = `<video preload="auto" id="${id}" crossorigin  loop="true" webkit-playsinline playsinline >`;
    if (src.endsWith('webm')) {
      html += `<source  type="video/webm"  src="${src}">`;
    } else if (src.endsWith('m3u8')) {
      // hls
      html += `<source src="${src}" type="application/x-mpegURL" />`;
    } else {
      html += `<source src="${src}" type="video/mp4">`;
    }
    html += `<h3>Error : Your browser does not support.</h3>`;
    html += `</video>`;
    return html;
  }

  codeGenerateCore(block: BlockType): string {
    let attribute = CodeSetting.getSubAttributeCode(block);
    // let src = CodeSetting.getFieldValue(block, "src");
    const id = this.hashedId(block);
    const elementTagName = CodeSetting.getFieldValue(block, 'type');
    const playAttribute = CodeSetting.getFieldValue(block, 'play');

    attribute += CodeSetting.getVR3FieldValues(block, 'position');
    attribute += CodeSetting.getAttributeCode('src', `#${id}`);
    attribute += CodeSetting.getAttributeCode('sound_start', `by:${playAttribute}`);
    attribute += CodeSetting.getAttributeCode('class', 'clickable collidable');
    const str = CodeSetting.getElementCode(elementTagName, attribute, block.id, '');
    return str;
  }
}
